import type { FrameSpec } from '../config/frames';
import type { MeshPhysicalMaterial } from 'three';

// Source-photo inventory A198: patterned acetate, including names that do not
// say “tortoise”. Selection is explicit; a new solid colour never opts in by accident.
const PATTERNED_FRONT = new Set([
  "airmax-1",
  "airmax-4",
  "bali-blue-caramel-swirl",
  "bali-blue-dark-forest-1",
  "bali-blue-morning-lagoon-1",
  "bali-blue-pink-lemonade",
  "bellini-babe-2",
  "bellini-bombshell",
  "bellini-brilliance",
  "borneo-bliss-black-sun",
  "borneo-bliss-dark-forest-1",
  "bourbon-bold-2",
  "bourbon-buzz",
  "bourbon-buzz-1",
  "bourbon-sidecar",
  "bramble-lover",
  "bushwacker",
  "cherry-blossom-breeze-1",
  "cove-1",
  "cove-tortoise",
  "daiquiri-dream",
  "elderflower-enemy",
  "flores-breeze-morning-lagoon-1",
  "french-seventy-five",
  "gili-escape-caramel-swirl-1",
  "gilmet-joy",
  "handmade-1",
  "java-joy-caramel-swirl",
  "java-joy-morning-lagoon-1",
  "java-jungle-caramel-swirl-1",
  "java-jungle-sunset-glow-1",
  "jungle-bird",
  "komodo-rise-caramel-swirl",
  "lilt",
  "lombok-luxe-black-sun-1",
  "lombok-luxe-tuxedo-tranquility-1",
  "luxe-caramel-swirl",
  "magnetic-martini-copy",
  "mahogany-mirage",
  "manhattan-magic",
  "margarita-mojo",
  "margarita-muse",
  "midnight-mimosa",
  "milky-punch",
  "milky-punch-1",
  "milky-punch-copy",
  "mimosa-marvel",
  "monaco-moment",
  "moon-river",
  "moon-river-2",
  "mudslide",
  "muse-1",
  "mysterious-martini",
  "mysterious-martini-copy",
  "nebula",
  "nostalgia",
  "ocean-s-embrace-copy",
  "paloma-perfection",
  "paloma-perfection-2",
  "pisco-sour",
  "pisco-sour-1",
  "raja-reef-morning-lagoon",
  "rob-roy",
  "rose-radiance",
  "sake-shades",
  "secret-serendipity",
  "sgroppino",
  "shindig",
  "shindig-2",
  "shindig-copy",
  "silfira",
  "slate-sour",
  "solace",
  "solivina",
  "soulstice",
  "stereo",
  "sumba-hills-black-sun",
  "tequila-sunrise",
  "tequila-temptation",
  "the-abyss",
  "the-abyss-2",
  "vieux-carre",
  "vino-vision",
  "vino-vision-1",
]);
// Crystal fronts keep their neutral material; only their tortoise temples continue
// through their thickness. Metal sections are classified separately afterwards.
const PATTERNED_TEMPLE_ONLY = new Set([
  'flores-breeze-sunlight-aura', 'raja-reef-sunlight-aura', 'sumba-hills-sunlight-aura',
]);
export function acetateEdgePattern(spec: Pick<FrameSpec, 'id'>): { front: boolean; temple: boolean } {
  const front = PATTERNED_FRONT.has(spec.id);
  return { front, temple: front || PATTERNED_TEMPLE_ONLY.has(spec.id) };
}

/** Continue the same source albedo over the extrusion. Geometry UVs are inset
 * into the photographed acetate; no background/lens image is projected onto it.
 * Share the already-loaded texture: no extra image download or GPU allocation.
 * This extends the observed pattern, rather than claiming an unseen 3D scan. */
export function textureAcetateWall(wall: MeshPhysicalMaterial, photo: MeshPhysicalMaterial): void {
  wall.map = photo.map;
  wall.color.copy(photo.color);
  wall.emissive.set('#000000');
  wall.userData.photoPatternWall = true;
}
